// extracted by mini-css-extract-plugin
export default {"root":"GrayInfoBox_root__LeOOO","label":"GrayInfoBox_label__BbolF","textContainer":"GrayInfoBox_textContainer__2MDzZ"};